/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type DimensioningParameterFragment = {
  __typename: "DimensioningParameter"
  default?: any
  readOnly?: boolean | null
  title?: string | null
  type?: string | null
  unit?: string | null
}

export type DimensioningOptionFragment = {
  __typename: "DimensioningOption"
  dimensioningKey: string
  configurationKey?: string | null
  properties?: any
  variantKeyRelatedData?: Array<{
    __typename: "DimensioningParameter"
    default?: any
    readOnly?: boolean | null
    title?: string | null
    type?: string | null
    unit?: string | null
  }> | null
  physicalData?: Array<
    | {
        __typename: "DataTable"
        description?: string | null
        body?: Array<Array<{
          __typename: "DataTableCell"
          index?: number | null
          key?: string | null
          value?: any
        }> | null> | null
        header?: Array<{
          __typename: "DataTableCell"
          index?: number | null
          key?: string | null
          value?: any
        }> | null
      }
    | {
        __typename: "DimensioningParameter"
        default?: any
        readOnly?: boolean | null
        title?: string | null
        type?: string | null
        unit?: string | null
      }
  > | null
}

export type ProductConfigurationResponseSimpleFragment = {
  __typename: "ProductConfigurationResponse"
  id: string
  configurationKey?: string | null
  dimensioningKey?: string | null
  variantKey?: string | null
  productType?: string | null
  accessories?: Array<string> | null
  schema?: any
  error?: string | null
  errors?: Array<{
    __typename: "APIError"
    code: string
    message?: string | null
    cause?: any
  }> | null
}

export type ProductConfigurationResponseFragment = {
  __typename: "ProductConfigurationResponse"
  id: string
  configurationKey?: string | null
  dimensioningKey?: string | null
  variantKey?: string | null
  productType?: string | null
  accessories?: Array<string> | null
  schema?: any
  error?: string | null
  dimensioningOptions?: Array<{
    __typename: "DimensioningOption"
    dimensioningKey: string
    configurationKey?: string | null
    properties?: any
    variantKeyRelatedData?: Array<{
      __typename: "DimensioningParameter"
      default?: any
      readOnly?: boolean | null
      title?: string | null
      type?: string | null
      unit?: string | null
    }> | null
    physicalData?: Array<
      | {
          __typename: "DataTable"
          description?: string | null
          body?: Array<Array<{
            __typename: "DataTableCell"
            index?: number | null
            key?: string | null
            value?: any
          }> | null> | null
          header?: Array<{
            __typename: "DataTableCell"
            index?: number | null
            key?: string | null
            value?: any
          }> | null
        }
      | {
          __typename: "DimensioningParameter"
          default?: any
          readOnly?: boolean | null
          title?: string | null
          type?: string | null
          unit?: string | null
        }
    > | null
  }> | null
  originalConfiguration?: {
    __typename: "ProductConfigurationResponse"
    id: string
    configurationKey?: string | null
    dimensioningKey?: string | null
    variantKey?: string | null
    productType?: string | null
    accessories?: Array<string> | null
    schema?: any
    error?: string | null
    errors?: Array<{
      __typename: "APIError"
      code: string
      message?: string | null
      cause?: any
    }> | null
  } | null
  errors?: Array<{
    __typename: "APIError"
    code: string
    message?: string | null
    cause?: any
  }> | null
}

export type DataTableFragment = {
  __typename: "DataTable"
  description?: string | null
  body?: Array<Array<{
    __typename: "DataTableCell"
    index?: number | null
    key?: string | null
    value?: any
  }> | null> | null
  header?: Array<{
    __typename: "DataTableCell"
    index?: number | null
    key?: string | null
    value?: any
  }> | null
}

export type DataTableCellFragment = {
  __typename: "DataTableCell"
  index?: number | null
  key?: string | null
  value?: any
}

export type ProductConfigurationModelDimInfoFragment = {
  __typename: "ProductConfigurationModelDimInfo"
  label: string
  url: string
}

export type ProductConfigurationModelFollowUpFragment = {
  __typename: "ProductConfigurationModelFollowUp"
  id?: string | null
  dimUrl?: Array<{
    __typename: "ProductConfigurationModelDimInfo"
    label: string
    url: string
  }> | null
}

export type ProductConfigurationModelFragment = {
  __typename: "ProductConfigurationModel"
  id?: string | null
  dimUrl?: Array<{
    __typename: "ProductConfigurationModelDimInfo"
    label: string
    url: string
  }> | null
  followUps?: Array<{
    __typename: "ProductConfigurationModelFollowUp"
    id?: string | null
    dimUrl?: Array<{
      __typename: "ProductConfigurationModelDimInfo"
      label: string
      url: string
    }> | null
  }> | null
}

export type ProductConfigurationModelsFragment = {
  __typename: "ProductConfigurationModels"
  models?: Array<{
    __typename: "ProductConfigurationModel"
    id?: string | null
    dimUrl?: Array<{
      __typename: "ProductConfigurationModelDimInfo"
      label: string
      url: string
    }> | null
    followUps?: Array<{
      __typename: "ProductConfigurationModelFollowUp"
      id?: string | null
      dimUrl?: Array<{
        __typename: "ProductConfigurationModelDimInfo"
        label: string
        url: string
      }> | null
    }> | null
  }> | null
}

export const ProductConfigurationResponseSimpleFragmentDoc = gql`
  fragment ProductConfigurationResponseSimple on ProductConfigurationResponse {
    id
    configurationKey
    dimensioningKey
    variantKey
    productType
    accessories
    schema
    error
    errors @type(name: "APIError") {
      code
      message
      cause
    }
  }
`
export const DimensioningParameterFragmentDoc = gql`
  fragment DimensioningParameter on DimensioningParameter {
    default
    readOnly
    title
    type
    unit
  }
`
export const DataTableCellFragmentDoc = gql`
  fragment DataTableCell on DataTableCell {
    index
    key
    value
  }
`
export const DataTableFragmentDoc = gql`
  fragment DataTable on DataTable {
    description
    body @type(name: "DataTableCell") {
      ...DataTableCell
    }
    header @type(name: "DataTableCell") {
      ...DataTableCell
    }
  }
  ${DataTableCellFragmentDoc}
`
export const DimensioningOptionFragmentDoc = gql`
  fragment DimensioningOption on DimensioningOption {
    dimensioningKey
    configurationKey
    variantKeyRelatedData @type(name: "DimensioningParameter") {
      ...DimensioningParameter
    }
    physicalData {
      ... on DimensioningParameter {
        ...DimensioningParameter
      }
      ... on DataTable {
        ...DataTable
      }
    }
    properties
  }
  ${DimensioningParameterFragmentDoc}
  ${DataTableFragmentDoc}
`
export const ProductConfigurationResponseFragmentDoc = gql`
  fragment ProductConfigurationResponse on ProductConfigurationResponse {
    ...ProductConfigurationResponseSimple
    dimensioningOptions @type(name: "DimensioningOption") {
      ...DimensioningOption
    }
    originalConfiguration @type(name: "ProductConfigurationResponse") {
      ...ProductConfigurationResponseSimple
    }
  }
  ${ProductConfigurationResponseSimpleFragmentDoc}
  ${DimensioningOptionFragmentDoc}
`
export const ProductConfigurationModelDimInfoFragmentDoc = gql`
  fragment ProductConfigurationModelDimInfo on ProductConfigurationModelDimInfo {
    label
    url
  }
`
export const ProductConfigurationModelFollowUpFragmentDoc = gql`
  fragment ProductConfigurationModelFollowUp on ProductConfigurationModelFollowUp {
    id
    dimUrl @type(name: "ProductConfigurationModelDimInfo") {
      ...ProductConfigurationModelDimInfo
    }
  }
  ${ProductConfigurationModelDimInfoFragmentDoc}
`
export const ProductConfigurationModelFragmentDoc = gql`
  fragment ProductConfigurationModel on ProductConfigurationModel {
    id
    dimUrl @type(name: "ProductConfigurationModelDimInfo") {
      ...ProductConfigurationModelDimInfo
    }
    followUps @type(name: "ProductConfigurationModelFollowUp") {
      ...ProductConfigurationModelFollowUp
    }
  }
  ${ProductConfigurationModelDimInfoFragmentDoc}
  ${ProductConfigurationModelFollowUpFragmentDoc}
`
export const ProductConfigurationModelsFragmentDoc = gql`
  fragment ProductConfigurationModels on ProductConfigurationModels {
    models @type(name: "ProductConfigurationModel") {
      ...ProductConfigurationModel
    }
  }
  ${ProductConfigurationModelFragmentDoc}
`
